import { ExtendedNextLink } from 'components/Basic/ExtendedNextLink/ExtendedNextLink';
import { useMapContext } from 'context/Map/useMapContext';
import { RemoveIcon } from 'public/svg/IconsSvg';
import { twJoin } from 'tailwind-merge';
import { MapMarkerType } from 'types/map';

export const PointMapCard: FC<{ activeMarker: MapMarkerType | undefined }> = ({ activeMarker }) => {
    const [, dispatch] = useMapContext();

    if (!activeMarker) {
        return null;
    }

    return (
        <div
            className={twJoin(
                'absolute bottom-0 z-two min-w-[240px] -translate-x-1/2 -translate-y-1/3 rounded-md bg-white bg-opacity-90 p-4 text-small text-black',
                'md:min-w-[280px] md:border-0 md:p-6 md:text-h6',
            )}
        >
            {activeMarker.storeSlug ? (
                <ExtendedNextLink href={activeMarker.storeSlug} type="store">
                    <>{activeMarker.storeName}</>
                </ExtendedNextLink>
            ) : (
                <div>{activeMarker.storeName}</div>
            )}
            <div>{activeMarker.storeStreet}</div>
            <div>{activeMarker.storeCity}</div>
            <div
                className="absolute right-2 top-2 cursor-pointer"
                onClick={() => dispatch({ type: 'setActiveMarkerUuid', payload: undefined })}
            >
                <RemoveIcon />
            </div>
        </div>
    );
};
